import { IIssue, TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useTableActions } from 'legacy/lut/components/widgets/public/partner360/ELT/hooks/useTableActions'
import { getIssueColumns } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/financialSnapshot/issues/getIssueColumns'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { useMemo } from 'react'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

import styles from './Issues.module.scss'

interface IProps {
  data: IIssue[]
  updateFormData: (data: TComplexSectionData) => void
}

const newEmptyRow: IIssue = { Issue: '', Status: 'New', HpResponse: '' }
export const Issues = ({ data, updateFormData }: IProps) => {
  const { addRow, deleteRow, deleteLastRow, onChange, canAddNewRow } = useTableActions<IIssue>({
    updateFormData: updateFormData,
    data: data,
    newEmptyRow,
    canAddNewRowCondFn: (el) => !el.Issue && !el.Status && !el.HpResponse,
  })
  const columns = useMemo(() => getIssueColumns({ onChange }), [data])
  return (
    <div className={styles.root}>
      <StyledTable<IIssue>
        title={getFormedEltTranslation('section-issues')}
        canAddNewRow={canAddNewRow}
        columns={columns}
        items={data}
        addRow={addRow}
        deleteLastRow={deleteLastRow}
        deleteRow={deleteRow}
        maxLen={5}
      />
    </div>
  )
}
